import { render, staticRenderFns } from "./GhostRatingConfirmation.vue?vue&type=template&id=f3c87aa4&scoped=true&"
import script from "./GhostRatingConfirmation.vue?vue&type=script&lang=js&"
export * from "./GhostRatingConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./GhostRatingConfirmation.vue?vue&type=style&index=0&id=f3c87aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c87aa4",
  null
  
)

export default component.exports